import $ from 'jquery';
import smartTab from 'jquery-smarttab';
export default function() {
    smartTab();

    $('.jstab').each(function () {
        const $animation = $(this).data('animation') || 'none';
        $(this).smartTab({
            autoAdjustHeight: false,
            keyboard: {
                keyNavigation: false,
            },
            transition: {
                animation: $animation
            },
            style: {
                mainCss: 'jstab',
                navCss: 'jstab-nav',
                navLinkCss: 'jstab-nav-link',
                contentCss: 'jstab-content',
                contentPanelCss: 'jstab-pane',
                themePrefixCss: 'jstab-theme-',
                justifiedCss: 'jstab-justified',
                anchorDefaultCss: 'default',
                anchorActiveCss: 'active',
                loaderCss: 'jstab-loading'
            },
        });
    });
}
